
const Conditions = {
    'clm' : 'Chlamydia',
    'gna' : 'Gonorrhea',
    'prt' : 'Pertussis',
    'slm' : 'Salmonellosis',
    'zka' : 'Zika',
    'ebl' : 'Ebola',
};

export default Conditions;